export default "__VITE_ASSET__VIT34b6O__"